import { ProductBasicInfo, ProductDetailInfo, ProductEntry, ProductReviewInfo, ResponseJson1 } from "../types/Product";
const defaultTagList = ["Image_Quality", "Value_for_Money", "Easy_of_Use", "Durability", "Portability", "Duribility", "Beginner_Friendly"];
const localhostAdress = process.env.NEXT_PUBLIC_LOCAL_HOST as string;
const remoteAddress = process.env.NEXT_PUBLIC_BACKEND_API as string;

/**
 * Set the host modes, it has 2 different modes:
 * 0 - localhost, the server will run locally
 * 1 - remote, the server will run remotely
 */
const hostMode: number = 1;

/**
 * 
 * @param id This function is used to fetch the related blogs and videos from the server
 * @returns 
 */
export const fetchProductUserContent = async (productId: number): Promise<[any[], any[]]> => {
  const hostAddress = hostMode === 0 ? localhostAdress : remoteAddress;
  const url = new URL(hostAddress + "/api/getProductUserContent/");
  const requestData = {
    category: "camera",
    id: productId
  };
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(requestData),
    cache: "no-cache"
  });
  if (!response.ok) {
    console.log("response", response);
    throw new Error("Failed to fetch search results");
  }
  const responseJson = await response.json();
  const videos: any[] = responseJson.videos[0]?.video ?? [];
  const blogs: any[] = responseJson.blogs[0]?.blog ?? [];
  return [videos, blogs];
};

/**
	 * 
	 * @param searchTerm This function is used to fetch the search results from the server
	 * @returns 
	 */
export const fetchContextualSearchResults = async (searchTerm: string): Promise<[ProductEntry[], string[]]> => {
  const hostAddress = hostMode === 0 ? localhostAdress : remoteAddress;
  const url1 = new URL(hostAddress + "/api/getRelatedTags/");

  //Request construction for the 1st request.
  const requestData1 = {
    context: searchTerm
  };
  const response1 = await fetch(url1, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(requestData1)
  });
  if (!response1.ok) {
    console.log("response", response1);
    return [[], []];
  }
  const responseJson1: ResponseJson1 = await response1.json();
  const cleanedTagList: string[] = (responseJson1.tag_list ? responseJson1.tag_list : defaultTagList).map(tag => tag.trim());

  //Request construction for the 2nd request.
  const url2 = new URL(hostAddress + "/api/getProductResultWithContext/");
  const requestData2 = {
    context: searchTerm,
    tag_list: cleanedTagList,
    brand_list: responseJson1.brand_list,
    sub_category_list: responseJson1.sub_category_list
  };
  const response2 = await fetch(url2, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(requestData2)
  });
  if (!response2.ok) {
    console.log("response", response2);
    return [[], []];
  }

  // const responseJson: ProductEntry[] = await response.json();

  // return responseJson;
  const responseJson2 = await response2.json();
  if (!Array.isArray(responseJson2.product_all_info)) {
    console.error('Expected responseJson.product_all_info to be an array');
    throw new Error("Invalid response format");
  }
  return [responseJson2.product_all_info as ProductEntry[], cleanedTagList];
};

// This function is used to clean the search results, it will replace “_” with “ ” and “null” with “N/A”
export const cleanSearchResults = (product_all_info: ProductEntry[], tagList?: string[]): [ProductEntry[], ProductReviewInfo[]] => {
  let reviewSummaryList: ProductReviewInfo[] = [];
  let product_all_info_cleaned: ProductEntry[] = [];
  if (!product_all_info || product_all_info.length === 0) {
    console.log(" clean search result in utils, no product information found");
    return [[], []];
  }
  product_all_info.forEach((product, index) => {
    let productBasicInfo: ProductBasicInfo = product[0];
    let productDetailInfo: ProductDetailInfo = product[1];
    let productReviewInfo: ProductReviewInfo = product[2];
    let reviewSummary: {
      [key: string]: Array<number>;
    } = {};
    Object.entries(productDetailInfo).forEach(([key, value]) => {
      let newKey = "";
      if (key !== null && typeof key === 'string' && key.includes("_")) {
        newKey = key.replace(/_/g, " ");
        productDetailInfo[newKey] = value;
        delete productDetailInfo[key];
      }
    });
    Object.entries(productReviewInfo).forEach(([key, value]) => {
      let newKey = "";
      if (key !== null && typeof key === 'string' && key.includes("_") && tagList?.includes(key)) {
        newKey = key.replace(/_/g, " ");
        productReviewInfo[newKey] = value;
        delete productReviewInfo[key];
      } else if (!tagList?.includes(key) && key !== "positive" && key !== "neutral" && key !== "negative") {
        delete productReviewInfo[key];
      } else if (key === "id") {
        delete productReviewInfo[key];
      } else if (key === "positive" || key === "neutral" || key === "negative") {
        reviewSummary[key] = value;
        delete productReviewInfo[key];
      }
    });
    reviewSummaryList[index] = reviewSummary;
    product_all_info_cleaned[index] = [productBasicInfo, productDetailInfo, productReviewInfo];
    // console.log('reviewSummaryList',reviewSummaryList);
  });

  //console.log("product_all_info_cleaned", product_all_info_cleaned[1][2]);
  return [product_all_info_cleaned, reviewSummaryList];
};